import { render, staticRenderFns } from "./RequestAnamnesisDetails.vue?vue&type=template&id=ddb0c00c"
import script from "./RequestAnamnesisDetails.vue?vue&type=script&lang=js"
export * from "./RequestAnamnesisDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports